// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"348":"3d70c998","590":"b80d79fc"}[chunkId] + ".css";
};